import React from 'react';
import { Controller } from 'react-hook-form';
import {
  Dialog, DialogContent, DialogActions, Button,
  useMediaQuery, useTheme,
} from '@mui/material';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import ModalHeader from '../ui/ModalHeader';
import { ProjectForm } from '../../../../components/Forms';

export function CreateProjectModal({
  open, onClose, saving, onSubmit,
  form, date, setDate, dateEnd, setDateEnd, includeVAT, setIncludeVAT,
  cost, setCost, extraGpsSites, setExtraGpsSites, allEmployees, contacts,
  selectedClient, setSelectedClient, setValue,
}) {
  const { control, handleSubmit } = form;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 3 } }}
    >
      <ModalHeader
        icon={<BusinessCenterOutlinedIcon fontSize="small" />}
        title="สร้างโครงการจากโอกาสทางธุรกิจ"
        subtitle="ระบบดึงชื่อโครงการ มูลค่างาน และผู้ว่าจ้างมาจากโอกาสทางธุรกิจนี้ให้แล้ว ที่เหลือกรอกเพิ่มได้เลย"
        onClose={onClose}
        disabled={saving}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <ProjectForm
            Controller={Controller}
            control={control}
            date={date}
            setDate={setDate}
            dateEnd={dateEnd}
            setDateEnd={setDateEnd}
            employee={allEmployees}
            includeVAT={includeVAT}
            setIncludeVAT={setIncludeVAT}
            cost={cost}
            setCost={setCost}
            extraGpsSites={extraGpsSites}
            setExtraGpsSites={setExtraGpsSites}
            contacts={contacts}
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            setValue={setValue}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }} disabled={saving}>ยกเลิก</Button>
          <Button type="submit" variant="contained" color="secondary" disabled={saving} sx={{ borderRadius: 2 }}>
            {saving ? 'กำลังบันทึก...' : 'สร้างโครงการ'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default CreateProjectModal;
